import { HStack, StackItem, VStack } from '@astryxdesign/core/Stack';
import { IconButton } from '@astryxdesign/core/IconButton';
import { Icon } from '@astryxdesign/core/Icon';
import { X } from '@phosphor-icons/react';
import { Drawer, DrawerContent, DrawerDescription, DrawerHeader, DrawerTitle } from '@/components/ui/drawer';
import { AssistantChat } from '@/components/AssistantChat';
import { useTenant } from '@/app/tenant-context';

export function AssistantSheet({
  open,
  onOpenChange,
  initialQuestion,
  onBook,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  initialQuestion?: string;
  onBook: (serviceId?: string) => void;
}) {
  const { slug, tenant } = useTenant();
  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent>
        <DrawerHeader>
          <HStack vAlign="center">
            <StackItem size="fill">
              <DrawerTitle>Помощник {tenant.short_name}</DrawerTitle>
            </StackItem>
            <IconButton label="Закрыть" icon={<Icon icon={X} />} variant="ghost" onClick={() => onOpenChange(false)} />
          </HStack>
          <DrawerDescription>Отвечает только по данным студии: услуги, цены, свободное время, адрес.</DrawerDescription>
        </DrawerHeader>
        <VStack paddingInline={4} paddingBlockEnd={6} isScrollable className="safe-bottom min-h-0">
          {open && (
            <AssistantChat
              key={initialQuestion ?? 'free'}
              slug={slug}
              scope="client"
              suggestions={tenant.assistant_suggestions}
              initialQuestion={initialQuestion}
              intro="Здравствуйте! Помогу выбрать услугу и время. Записать можно прямо отсюда."
              onAction={(a) => a.type === 'open_booking' && onBook(a.service_id)}
            />
          )}
        </VStack>
      </DrawerContent>
    </Drawer>
  );
}
